<template>
	<div class="synchronize-companies-list">
		<v-flex ma-4>
			<v-flex xs2>
				<v-layout xs2 mb-4 align-center>
					<v-select
						background-color="white"
						box
						class="body-1 mt-2"
						hide-details
						item-text="name"
						item-value="id"
						label="Estado"
						:items="status"
						v-model="params.status"
						@input="changeStatus"
						append-icon="close"
						@click:append="changeStatus(null)"
					></v-select>
				</v-layout>
			</v-flex>
			<app-table
				class="mt-3 is-not-selectable"
				name="synchronize-companies"
				:columns="columns"
				:rows="rowsCompany"
				:items-quantity="rowsCompany.length"
				:items-total-quantity="itemsTotalQuantity"
				:current-page="currentPage"
				:last-page="lastPage"
				@on-search-event="onSearch"
				@on-page="changePage"
			>
				<template slot="rows" slot-scope="props">
					<td v-show="showRow(columns, 1)" class="is-not-selectable">
						{{ props.row.ruc }}
					</td>
					<td v-show="showRow(columns, 2)" class="is-not-selectable">
						{{ props.row.razSoc }}
					</td>
					<td v-show="showRow(columns, 3)">
						{{ props.row.email || '-' }}
					</td>
					<td v-show="showRow(columns, 4)">
						{{ props.row.phone }}
					</td>
					<td v-show="showRow(columns, 5)">
						{{ props.row.orderNumber || '-' }}
					</td>
					<td v-show="showRow(columns, 6)">
						{{ props.row.employeeName || '-' }}
					</td>
					<td v-show="showRow(columns, 7)">
						{{ props.row.salesId || '-' }}
					</td>
					<td v-show="showRow(columns, 8)">
						{{ props.row.domain || '-' }}
					</td>
					<td v-show="showRow(columns, 9)">
						{{ props.row.companyId || '-' }}
					</td>
					<td v-show="showRow(columns, 10)">
						<span :style="{ color: props.row.processName.color, textShadow: '0.5px 0.5px 0 ' + props.row.processName.color}">
							{{ props.row.processName.name }}
						</span>
					</td>
					<td v-show="showRow(columns, 11)">
						{{ props.row.country.name }}
					</td>
					<td v-show="showRow(columns, 12)">
						{{ props.row.planCode }}
					</td>
					<td v-show="showRow(columns, 13)">
						<span :style="{ color: props.row.statusName.color, textShadow: '0.5px 0.5px 0 ' + props.row.statusName.color}">
							{{ props.row.statusName.name }}
						</span>
					</td>
					<td v-show="showRow(columns, 14)">
						{{ props.row.dateBlocked }}
					</td>
					<td v-show="showRow(columns, 15)">
						{{ props.row.convertedAt }}
					</td>
					<td v-show="showRow(columns, 16)">
						<app-tooltip-button
							color="green"
							icon="edit"
							text="Editar"
							@click-icon="goEdit(props.row)"
						/>
						<app-tooltip-button
							v-if="props.row.logs && props.row.logs.length > 1"
							color="red"
							icon="history"
							text="Ver logs"
							@click-icon="openLogsDialog(props.row)"
						/>
					</td>
				</template>
			</app-table>
		</v-flex>
		<v-dialog v-model="logsDialog" max-width="600" :persistent="isRetrying">
			<v-card>
				<v-card-title class="subheading">Registros de Errores</v-card-title>
				<v-card-text class="logs-dialog-content">
					<div
						v-for="(log, index) in selectedLogs"
						:key="index"
						class="log-item"
					>
						<div class="log-item-header">
							<span class="log-item-process">Proceso: {{ getProcessName(log.processId) }}</span>
							<v-tooltip v-if="log.processId === 3 || log.processId === 4" top>
								<v-btn
									slot="activator"
									class="btn-action caption ma-0"
									color="orange"
									dark
									small
									:loading="isRetrying"
									:disabled="isRetrying"
									@click.native="retryProcess(log)"
								>
									<v-icon small class="mr-1">sync</v-icon>
									Reintentar
								</v-btn>
								<span>Reintentar sincronización</span>
							</v-tooltip>
						</div>
						<span class="log-item-code">Código: {{ log.codeResponse }}</span>
						<p class="log-item-error mb-0">
							<strong>Error:</strong> {{ log.bodyResponse }}
						</p>
					</div>
				</v-card-text>
				<v-card-actions class="justify-center">
					<v-btn
						class="btn-action"
						color="primary"
						dark
						:disabled="isRetrying"
						@click.native="closeLogsDialog"
					>
						Cerrar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<router-view></router-view>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';

function created() {
	this.loadData();
	if (this.$route.name === 'synchronize-companies-list') {
		this.columns[15].checked = false;
		this.columns[15].visible = false;
		this.columns[15].flagVisible = true;
	}
}

function onSearch(search) {
	this.params.search = search ? search.trim() : null;
	this.loadData();
}

function data() {
	return {
		columns: [
			{ id: 1, name: '#Compañia', value: 'numberCompany', checked: true, visible: true },
			{ id: 2, name: 'Nombre', value: 'name', checked: true, visible: true },
			{ id: 3, name: 'Correo', value: 'email', checked: false, visible: false },
			{ id: 4, name: 'Teléfono', value: 'phone', checked: true, visible: true },
			{ id: 5, name: '#Pedido', value: 'numberOrder', checked: true, visible: true },
			{ id: 6, name: 'Empleado', value: 'employeeName', checked: true, visible: true },
			{ id: 7, name: 'IdVenda', value: 'idsale', checked: true, visible: true },
			{ id: 8, name: 'Dominio', value: 'domain', checked: false, visible: false },
			{ id: 9, name: 'AclCompañia', value: 'aclCompany', checked: true, visible: true },
			{ id: 10, name: 'Proceso', value: 'processId', checked: true, visible: true },
			{ id: 11, name: 'País', value: 'country', checked: false, visible: false },
			{ id: 12, name: 'Plan', value: 'plan', checked: true, visible: true },
			{ id: 13, name: 'Estado', value: 'estatus', checked: true, visible: true },
			{ id: 14, name: 'Fecha de bloqueo', value: 'dateBlocked', checked: true, visible: true },
			{ id: 15, name: 'Fecha de creación', value: 'dateCreated', checked: true, visible: true },
			{ id: 16, name: 'Acciones', value: 'action', checked: true, visible: true },
		],
		process: [
			{ id: 1, name: 'Compañia registrada' },
			{ id: 2, name: 'Usuario registrado' },
			{ id: 3, name: 'Registrado en notion' },
			{ id: 4, name: 'Registrado en cliente del notion' },
			{ id: 5, name: 'Notificación al usuario' },
			{ id: 6, name: 'Proceso de bloqueo' }
		],
		checkAll: false,
		status: [
			{
				id: 1,
				name: 'Registrado',
			},
			{
				id: 2,
				name: 'Pendiente',
			},
			{
				id: 3,
				name: 'Iniciado',
			},
			{
				id: 4,
				name: 'Finalizado',
			},
			{
				id: 5,
				name: 'Error',
			},
		],
		currentPage: 1,
		lastPage: 1,
		itemsTotalQuantity: 0,
		params: {
			status: null,
			page: 1,
			search: null,
			limit: 30,
			sortDirection: 'desc',
			sortField: 'created_at',
		},
		rows: [],
		rowsCompany: [],
		isClearing: false,
		logsDialog: false,
		selectedLogs: [],
		selectedCompanyId: null,
		isRetrying: false,
	};
}

function changePage(page) {
	this.currentPage = page;
	this.loadData();
}

async function loadData() {
	delete this.params.perPage;
	this.params.page = this.currentPage;
	try {
		const response = await this.$httpCompany.get('ext-companies', { params: this.params });
		this.lastPage = Number(response.headers['x-last-page']);
		this.itemsTotalQuantity = Number(response.headers['x-quantity']);
		this.rowsCompany = response.data.map((r) => {
			// const typeProcess = this.process.find((p) => p.id === r.processId);
			const [ruc, cliente, phone, implementa, phoneImple] = r.nombreSocial.split(' - ', 5);
			const newR = { ...r };
			newR.dateBlocked = r.dateBlocked ? r.dateBlocked.split('T')[0] : '-';
			newR.convertedAt = r.convertedAt ? new Date(r.convertedAt).toISOString().split('T')[0] : '-';
			newR.ruc = ruc;
			newR.cliente = cliente || implementa;
			newR.phone = phone || phoneImple || '-';
			return newR;
		});
	} catch (error) {
		this.showError();
	}
}

function goEdit(row) {
	const query = { data: JSON.stringify(row) };
	this.goTo('page-config-edit-synchronize', { query });
}

function openLogsDialog(row) {
	this.selectedLogs = row.logs;
	this.selectedCompanyId = row.id;
	this.logsDialog = true;
}

function closeLogsDialog() {
	if (this.isRetrying) {
		return;
	}
	this.logsDialog = false;
	this.selectedLogs = [];
	this.selectedCompanyId = null;
}

function getProcessName(processId) {
	const process = this.process.find(p => p.id === processId);
	return process ? process.name : 'Proceso desconocido';
}

async function retryProcess(log) {
	this.isRetrying = true;
	try {
		await this.$httpCompany.patch(`ext-companies/${this.selectedCompanyId}/process`, { processId: log.processId });
		this.showNotification('Se solicitó el reintento correctamente', 'success');
		this.loadData();
		this.isRetrying = false;
		this.closeLogsDialog();
	} catch (error) {
		this.showError();
		this.isRetrying = false;
	}
}

function newRoute(newValue) {
	if (newValue.name === 'page-config-synchronize-companies') {
		this.loadData();
	}
}

export default {
	name: 'synchronize-companies-list',
	created,
	data,
	components: {
		appTooltipButton,
	},
	methods: {
		changePage,
		loadData,
		goEdit,
		onSearch,
		openLogsDialog,
		closeLogsDialog,
		getProcessName,
		retryProcess,
		changeStatus(state) {
			this.params.status = state;
			this.loadData();
		},
	},
	watch: {
		$route: newRoute,
	},
};
</script>

<style lang="scss" scoped>
	.logs-dialog-content {
		max-height: 400px;
		overflow-y: auto;
	}

	.log-item {
		background: map-get($colors, grey);
		border-left: 4px solid map-get($colors, red-icon);
		border-radius: 2px;
		margin-bottom: 10px;
		padding: 8px 12px;

		&:last-child {
			margin-bottom: 0px;
		}
	}

	.log-item-header {
		align-items: center;
		display: flex;
		justify-content: space-between;
		margin-bottom: 4px;
	}

	.log-item-process {
		color: map-get($colors, black);
		font-family: map-get($fonts, open-bold);
	}

	.log-item-code {
		color: map-get($colors, black);
		display: block;
		font-size: 11px;
		margin-bottom: 4px;
	}

	.log-item-error {
		color: map-get($colors, red-icon);
		font-size: 13px;
		word-break: break-word;
	}
</style>


// WEBPACK FOOTER //
// src/components/configuration/synchronize-companies-list.vue